import styled from "styled-components";

export const Background = styled.div`
  width: 100vw;
  height: 85vh;
  display: flex;
  justify-content: center;
`;

export const Container = styled.div`
  width: 98vw;
  height: 85vh;
  display: flex;
  flex-direction: column;
`;

export const Menus = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: fit-content;

  .page {
    display: flex;
    flex-direction: column;
    color: #000;
    align-items: center;
    justify-content: center;
  }
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  z-index: 1;
  /* height: 100%; */
  gap: 20px;
`;

export const Title = styled.h1`
  padding: 10px 20px;
  color: var(--background);
  background-color: #1a2e35;
  white-space: nowrap;
  margin-top: 1.5%;
  font-weight: 200;
  font-size: #1a2e35;
  border-radius: 20px 20px 0px 0px;
`;

export const QtdeProgre = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--background);
  background-color: #1a2e35;
  white-space: nowrap;
  padding: 5px 10px;
  margin-top: 1.5%;
  margin-right: 1px;
  font-weight: 200;
  border-radius: 20px 20px 0px 0px;
`;

export const ContainerTable = styled.div`
  width: 100%;
  min-height: 60vh;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  border-bottom: 5px solid #1a2e35;
  border-radius: 0px 0px 10px 10px;
  color: #000;
`;

export const Table = styled.table`
  visibility: ${(props) => (props.Ativo ? "hidden" : "")};
  border-collapse: collapse;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  font-size: 0.9em;
  width: 100%;
  height: fit-content;

  width: 100%;
  table-layout: fixed;
`;

export const Theader = styled.thead`
  background-color: #1a2e35;
  color: #ffffff;
  text-align: center;
  position: sticky;
  top: 0;
  height: 8vh;
  font-size: 0.9rem;
  z-index: 9;
`;

export const Tbody = styled.tbody`
  height: fit-content;
`;

export const Trbody = styled.tr`
  border-bottom: 1px solid #dddddd;
  height: 50px;

  p {
    display: flex;
    margin-left: 20%;
    width: fit-content;
  }

  .red {
    color: red;
  }
  .green {
    color: green;
  }
  .max {
    max-width: 400px;
  }

  &:nth-of-type(even) {
    background-color: #f3f3f3;
  }

  transition: all 0.2s;

  &:hover {
    background-color: #bfbfbf;
    /* transform: scale(0.997); */
  }
`;

export const Th = styled.th`
  padding: 10px;
  font-weight: 500;
  text-align: center;
  overflow: hidden;
  text-overflow:ellipsis;

  div {
    display: flex;
    .icon {
      display: flex;
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
`;

export const Td = styled.td`
  padding: 2px 10px;
  text-align: center;

  vertical-align: middle;


  text-overflow: ellipsis;
  white-space: wrap;

  span {

    display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

 /* max-width: 400px; /* ajuste conforme necessário */
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis; */
  }

  .icon {
    transition: all 0.2s;
    color: var(--vermelhofiec);
    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const Grup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 2rem;

  width: 100%;

  input,
  select {
    width: 100%;
  }

  ::placeholder {
    color: #ffffff;
  }
`;
